import { NgModule, inject } from "@angular/core";
import { ActivatedRouteSnapshot, Route, RouterModule } from "@angular/router";

import { RoleGuardService as RoleGuard } from "@logex/framework/lg-application";

import { BootGuardService } from "@shared/guards/boot-guard.service";

import { AuthorizedComponent } from "./authorized.component";

const routes: Route[] = [
    {
        path: "",
        pathMatch: "full",
        redirectTo: "dashboard"
    },
    {
        path: "boot",
        loadChildren: () => import("./pages/boot/boot-pages.module").then(m => m.BootPagesModule)
    },
    {
        path: "",
        component: AuthorizedComponent,
        canActivate: [
            () => inject(BootGuardService).canActivate(),
            (route: ActivatedRouteSnapshot) => inject(RoleGuard).canActivate(route)
        ],
        canActivateChild: [
            () => inject(BootGuardService).canActivate(),
            (route: ActivatedRouteSnapshot) => inject(RoleGuard).canActivateChild(route)
        ],
        data: {
            navigationId: "root"
        },
        children: [
            {
                path: "dashboard",
                loadChildren: () =>
                    import("./pages/dashboard/dashboard.module").then(m => m.DashboardModule),
                data: {
                    navigationId: "dashboard"
                }
            },
            {
                path: "analysis",
                children: [
                    {
                        path: "practice-variation",
                        loadChildren: () =>
                            import("./pages/variation/practice-variation/page.module").then(
                                m => m.PracticeVariationModule
                            ),
                        data: {
                            navigationId: "practiceVariation"
                        }
                    },
                    {
                        path: "process-variation",
                        loadChildren: () =>
                            import("./pages/variation/process-variation/page.module").then(
                                m => m.ProcessVariationModule
                            ),
                        data: {
                            navigationId: "processVariation"
                        }
                    }
                ]
            },
            {
                path: "overview",
                children: [
                    {
                        path: "best-practices",
                        loadChildren: () =>
                            import("./pages/best-practices/page.module").then(
                                m => m.BestPracticesModule
                            ),
                        data: {
                            navigationId: "bestPractices"
                        }
                    },
                    {
                        path: "kpi",
                        loadChildren: () =>
                            import("./pages/kpi/page.module").then(m => m.KpiModule),
                        data: {
                            navigationId: "kpi"
                        }
                    },
                    {
                        path: "monitoring",
                        loadChildren: () =>
                            import("./pages/monitoring/page.module").then(m => m.MonitoringModule),
                        data: {
                            navigationId: "monitoring"
                        }
                    }
                ]
            }
        ]
    },
    {
        path: "settings",
        component: AuthorizedComponent,
        canActivate: [
            () => inject(BootGuardService).canActivate(),
            (route: ActivatedRouteSnapshot) => inject(RoleGuard).canActivate(route)
        ],
        canActivateChild: [
            () => inject(BootGuardService).canActivate(),
            (route: ActivatedRouteSnapshot) => inject(RoleGuard).canActivateChild(route)
        ],
        data: {
            navigationId: "settings"
        },
        children: [
            {
                path: "general",

                children: [
                    {
                        path: "costprice",
                        loadChildren: () =>
                            import("./pages/settings/general/general-settings.module").then(
                                m => m.GeneralSettingsModule
                            ),
                        data: {
                            navigationId: "settings-1-1"
                        }
                    }
                ]
            }
        ]
    },
    /** routes order matters. If segment hasn't been found redirect dashboard */
    { path: "**", redirectTo: "/dashboard" }
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {
            enableTracing: false
        })
    ],
    exports: [RouterModule]
})
export class AppRoutingModule {}
